import Page from "../../Components/Page";


export default function Orders() {
    return (
        <Page title="Orders" grid fullHeight>
        </Page>
    );
}
